<template>
  <div class="clients">
    <ag-table :data-source-api="getAllClients" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" @emitExportToExcel="onExportClientsExcelFile"
      @emitImportFromExcel="onImportClientsExcelFile">
      <template #action>
        <input
          type="file"
          ref="importPointsInput"
          class="hidden"
          accept=".csv"
          @change="onImportPointsFile"
        >
        <button
          @click="$refs.importPointsInput.click()"
          class="flex items-center btn_Option px-3 ml-4 export">
          <feather-icon icon="UploadIcon" class="mr-2 button_icon" />
          <span>استيراد النقاط من اليسير</span>
        </button>
        <button
          @click="onOpenSyncYaseerPopup"
          class="flex items-center btn_Option px-3 ml-4 export">
          <feather-icon icon="RefreshCwIcon" class="mr-2 button_icon" />
          <span>مزامنة نقاط اليسير</span>
        </button>
      </template>
    </ag-table>

    <tm-popup :submit="onSyncYaseerPopupSubmit" title="مزامنة نقاط اليسير" ref="syncYaseerPopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-select class="w-full" :options="getAppsOptions" label="name" validation-rules="required"
            name="المشروع" :reduce="app => app.id" v-model="syncYaseerForm.appId" />
        </div>
        <div class="vx-col w-full mb-2 mt-4">
          <input type="file" ref="syncYaseerFileInput" accept=".xlsx,.xls">
        </div>
      </div>
    </tm-popup>

    <tm-popup title="اخطاء الاستيراد" ref="importErrorsPopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-4">
          <ul v-if="Array.isArray(importingErros)" class="errors-list">
            <li v-for="(item, index) in importingErros" :key="index" class="errors-list-item">
              <template v-if="item && typeof item === 'object' && 'row' in item">
                <div class="errors-list-item-row">{{ item.row }}</div>
                <div class="errors-list-item-message">
                  {{ Array.isArray(item.error) ? item.error.join('، ') : item.error }}
                </div>
              </template>
              <template v-else>
                <div class="errors-list-item-message">{{ item }}</div>
              </template>
            </li>
          </ul>
          <p v-else class="errors-message">{{ importingErros }}</p>
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmSelect from "@/app/shared/shared-components/TmSelect";
import AgTableBtnCell from "../../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgTable from '../../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import { RepositoryFactory } from '../../loyalty-repositories/loyaltyRepositoryFactory';

const clientsRepo = RepositoryFactory.get('clientsRepository');
const appsRepo = RepositoryFactory.get('appsRepository');
export default {
  name: "Clients",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
    TmPopup,
    TmSelect
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      permissions: {},
      importingErros: {},
      apps: [],
      syncYaseerForm: {
        appId: null,
      },
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'المعرف',
          field: 'clientId',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: true
        },
        {
          headerName: 'اسم المستخدم',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'المشروع',
          field: 'appId',
          // filter: 'agTextColumnFilter',
          width: 200,
          sortable: true,
          valueGetter:
            function getObject(params) {
              return params.data.apps ? params.data.apps.map(app => app.name).join(",") : '-';
            },
        },
        {
          headerName: 'النقاط',
          filter: 'agNumberColumnFilter',
          field: 'points',
          width: 200,
          sortable: true,
        },
        {
          headerName: 'المستوى',
          filter: 'agTextColumnFilter',
          field: 'tierId',
          width: 200,
          sortable: true,
          valueGetter:
            function getObject(params) {
              return params.data.tier ? params.data.tier.name : '-';
            },
        },
        {
          headerName: 'الإجراءات',
          field: 'id',
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          cellRendererParams: {
            viewRecordDetails: function (client) {
              self.$router.push({ path: `/loyalty/clients/${client.id}/coupons` });
            },
            actions: ['view'],
            permissions: self.permissions
          },
        }
      ];
    },
    async getAllClients(query) {
      return await clientsRepo.fetchClients(query);
    },
    async onImportClientsExcelFile(file) {
      try {
        const res = await clientsRepo.importClients(file.rawFile);
        await this.gridApi.refreshServerSideStore({ purge: true });

        const errorData = res.data.errors;
        if (errorData && errorData.length) {
          this.$refs.importErrorsPopup.open();
          this.importingErros = errorData;
        }
      } catch (error) {
        // const errorData = error.response.data.errors;
        // if (!errorData) return;
        // this.$refs.importErrorsPopup.open();
        // this.importingErros = errorData;
      }
    },
    async onImportPointsFile(e) {
      const rawFile = e.target.files[0];
      this.$refs.importPointsInput.value = null;
      if (!rawFile) return;
      try {
        const res = await clientsRepo.importPoints(rawFile);
        await this.gridApi.refreshServerSideStore({ purge: true });

        const errorData = res.data.errors;
        if (errorData && errorData.length) {
          this.$refs.importErrorsPopup.open();
          this.importingErros = errorData;
        }
      } catch (error) {
        // handled globally by httpClient interceptors
      }
    },
    async onExportClientsExcelFile() {
      await clientsRepo.exportClients();
    },
    async getAllApps() {
      const res = await appsRepo.fetchApps();
      this.apps = res.data;
    },
    onOpenSyncYaseerPopup() {
      this.syncYaseerForm.appId = null;
      if (this.$refs.syncYaseerFileInput) {
        this.$refs.syncYaseerFileInput.value = null;
      }
      this.$refs.syncYaseerPopup.open();
    },
    async onSyncYaseerPopupSubmit() {
      const rawFile = this.$refs.syncYaseerFileInput.files[0];
      const appId = this.syncYaseerForm.appId;
      if (!rawFile || !appId) {
        this.$refs.syncYaseerPopup.endLoading();
        return;
      }
      try {
        const res = await clientsRepo.syncYaseerPoints(rawFile, appId);
        this.$refs.syncYaseerPopup.close();
        await this.gridApi.refreshServerSideStore({ purge: true });

        const summary = res.data;
        if (summary && summary.errors && summary.errors.length) {
          this.$refs.importErrorsPopup.open();
          this.importingErros = summary;
        }
      } catch (error) {
        this.$refs.syncYaseerPopup.endLoading();
        const body = (error.response && error.response.data) || {};
        const errorData = body.data || {};
        const details = errorData.errors || errorData.missingHeaders;
        this.$refs.syncYaseerPopup.close();
        this.$refs.importErrorsPopup.open();
        this.importingErros = details || body.message;
      }
    },
  },
  computed: {
    getAppsOptions() {
      return this.apps.filter(app => app.status === 'active').map(app => ({
        name: app.name,
        id: app.id
      }));
    }
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.getAllApps();
  }
};
</script>

<style scoped>
.errors-wrapper {
  font-weight: 700;
  direction: rtl;
  overflow-x: auto;
}

.errors-list {
  direction: rtl;
  max-height: 50vh;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}

.errors-list-item {
  padding: 10px 12px;
  border-right: 3px solid #ea5455;
  background-color: #fbe9e9;
  border-radius: 4px;
  margin-bottom: 8px;
}

.errors-list-item-row {
  font-size: 12px;
  color: #6e6b7b;
  word-break: break-word;
  margin-bottom: 4px;
}

.errors-list-item-message {
  font-weight: 600;
  color: #ea5455;
}

.errors-message {
  font-weight: 600;
  color: #ea5455;
  direction: rtl;
}
</style>
